export default "__VITE_ASSET__TJg$X96Y__"